import { useState } from "react";
import toastError from "../../errors/toastError";

export function useLocalStorage(key, initialValue) {
	const [storedValue, setStoredValue] = useState(() => {
		try {
			const item = localStorage.getItem(key);
			if (key === 'token') {
				return item ? item : initialValue;
			}
			return item ? JSON.parse(item) : initialValue;
		} catch (error) {
			toastError(error);
			return initialValue;
		}
	});

	const setValue = value => {
		try {
			const valueToStore =
				value instanceof Function ? value(storedValue) : value;

			setStoredValue(valueToStore);

			if (key === 'token') {
				localStorage.setItem(key, valueToStore);
			} else {
				localStorage.setItem(key, JSON.stringify(valueToStore));
			}
		} catch (error) {
			toastError(error);
		}
	};

	return [storedValue, setValue];
}